import * as axios from '~/utilities/axios'

export const autoLogin = sessionToken => {
  return axios
    .secure(sessionToken)
    .get(`/${process.env.PARSE_DIR}/users/me`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const verifiedLogin = (sessionToken, objectId) => {
  return axios
    .secure(sessionToken)
    .get(`/${process.env.PARSE_DIR}/users/${objectId}`)
    .then(res => {
      return res.data
    })
    .catch(axios.parseError)
}

export const login = (username, password) => {
  return axios.basic
    .post(`/${process.env.PARSE_DIR}/login`, {username, password})
    .then(res => res.data)
    .catch(axios.parseError)
}

export const googleAuth = authData => {
  return axios.basic
    .post(`/api/v1/auth/thirdParty/google`, authData)
    .then(res => res.data)
    .catch(error => {
      const data = error?.response?.data
      if (data?.message && typeof data.message === 'string') {
        return Promise.reject({
          message: data.message,
          code: data.code,
        })
      }
      return axios.parseError(error)
    })
}

export const facebookAuth = authData => {
  return axios.basic
    .post(`/api/v1/auth/thirdParty/facebook`, authData)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const allowInsuranceAccess = sessionToken => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/insurance/allowUser/`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const magicLinkSignIn = (userObjectId, token) => {
  return axios.basic
    .get(`/api/v1/magiclink/validate/${userObjectId}/${token}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const requestLoginMagicLink = (email, returnUrl) => {
  return axios.basic
    .post(`/api/v1/magiclink/requestLogin`, { email, returnUrl })
    .then(res => res.data)
    .catch(axios.parseError)
}

export const loginWithCode = (email, code) => {
  return axios.basic
    .post(`/api/v1/magiclink/validateCode`, { email, code })
    .then(res => res.data)
    .catch(axios.parseError)
}


export const logout = (sessionToken) => {
  return axios
    .secure(sessionToken)
    .post(`/${process.env.PARSE_DIR}/logout`)
}

export const sendPhoneNumberVerificationCode = (sessionToken) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/user/sendVerificationCode`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const checkPhoneNumberVerificationCode = (sessionToken, verificationCode) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/user/checkVerificationCode`, {verificationCode})
    .then(res => res.data)
    .catch(axios.parseError)
}
